"use client";
import React, { useState, useEffect } from 'react'
import styles from './CommunityGuidelines.module.css'
import Image from 'next/image'
const RIGHT_CHEVRON_WHITE = "/images/icons/right-chevron-white.svg"

interface Section { id: string, key_points: string[], title: string }

const sections: Section[] = [
    {
        title: 'Community Guidelines',
        id: 'community-guidelines',
        key_points: [
            'Mentors should not pitch products of services.',
            'Mentees should not pay to pitch investors.',
            'Both parties must respect confidentiality.',
            'Be present, on-time, and focused.',
            'Check your ego in the waiting room.',
            "Don't be an asshole.",
        ],
    },
    {
        title: 'Policies',
        id: 'policies',
        key_points: [
            'Refund unused credits w/in 15 days of purchase.',
            "Automatic refund if mentor doesn't respond.",
            'Cancel for free six hours before call.',
            '5-minute grace period on session overflow.',
            'Mentor cancel/no-show refunded.',
        ],
    },
]

const BasicDropdown = ({ id, key_points, title }: Section) => {

    const [showDropdown, setShowDropdown] = useState(true)
    const [desktop, setDesktop] = useState(true);

    useEffect(() => {
        if (window !== undefined) {
            setDesktop(window && window.innerWidth > 576)
        }
    }, [setShowDropdown]);

    const toggleDropDown = () => setShowDropdown(!showDropdown)

    return (
        <div>
            <div onClick={toggleDropDown} className={styles.title}>
                <h3>{title}</h3>
                {!desktop &&
                    <Image
                        src={RIGHT_CHEVRON_WHITE}
                        width={16}
                        height={16}
                        alt="right chevron"
                        className={`${showDropdown ? `${String(styles._down)} ${String(styles.chevron)}` : String(styles.chevron)}`}
                    />}
            </div>
            <ul className={`${String(styles.points)} ${showDropdown || desktop ? String(styles.active) : ""}`}>
                {key_points.map((point, index) => (
                    <li key={`${id}-${index}`}>{point}</li>
                ))}
            </ul>
        </div>
    )
}

const CommunityGuidelinesComponent = () => {
    return (
        <div className={styles.container}>
            {sections.map((section) => (
                <BasicDropdown key={section.id} {...section} />
            ))}
        </div>
    )
}

export default CommunityGuidelinesComponent
